'use strict'

module.exports = strong

var all = require('../all')

/* Transform importance. */
function strong(h, node) {
  return h(node, 'strong', all(h, node))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/strong.js
// module id = 903
// module chunks = 95715928098905 168707334958949